import { Box, CircularProgress, Typography } from '@mui/material'

const SearchLoading = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: { xs: 200, sm: 250 },
            p: { xs: 2, sm: 3 },
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: 3,
            border: '1px solid #e0e0e0'
        }}>
            <Box sx={{
                position: 'relative',
                display: 'inline-flex',
                mb: 2
            }}>
                <CircularProgress
                    size={60}
                    thickness={4}
                    sx={{
                        color: '#0364ff',
                        '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round',
                        }
                    }}
                />
            </Box>
            <Typography sx={{
                color: '#2d3748',
                fontWeight: 600,
                fontSize: { xs: 15, sm: 16 },
                textAlign: 'center'
            }}>
                Buscando resultados...
            </Typography>
            <Typography sx={{
                color: '#718096',
                fontSize: { xs: 12, sm: 13 },
                textAlign: 'center',
                mt: 0.5
            }}>
                Por favor espera un momento
            </Typography>
        </Box>
    )
}

export default SearchLoading
